// extracted by mini-css-extract-plugin
module.exports =  {"p-margin":"10px","pMargin":"10px","inline":"ring-markdown-inline","markdown":"ring-markdown-markdown ring-global-font"};